import { render, staticRenderFns } from "./manufacturerInfoList.vue?vue&type=template&id=6e955b9e"
import script from "./manufacturerInfoList.vue?vue&type=script&lang=js"
export * from "./manufacturerInfoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports